<template>
  <!-- <el-container>
      <el-aside class="aside" width="240px"><myelaside :menuList="menuList"  @func1="funcq" @func2="funcw"/></el-aside>
      <el-main width="auto"><router-view/></el-main>
    </el-container> -->
  <div>
    <el-container>
      <el-header ref="elheader"
                 :style="{'background':isCustom ? custom == 'xugong' ? 'url('+ xgbj +') no-repeat' : 'url('+ wcbj +') no-repeat' : isSimple ? 'url('+ hearerbjSimple +') no-repeat' : 'url('+ hearerbj +') no-repeat','backgroundSize': '100% 100%'}"
                 :class="headerClass">
        <myelheader />
      </el-header>
      <div ref="elheaderzw"
           class="elheaderzw"></div>
      <el-container >
        <el-aside style="width:auto;"
                  :class="isAside ? 'showaside' : isSimple ? 'simplehidaside' : 'hidaside'">
          <myelaside :asideList="asideList"
          v-if="$route.name!=='mediaResult'"
                     :hidasideList="hidasideList" />
        </el-aside>
        <el-main>
          <transition name="el-fade-in-linear">
            <keep-alive>
              <router-view v-if="isRouterAlive && $route.meta.keepAlive"
                           ref="chartView" />
            </keep-alive>
          </transition>

          <transition name="el-fade-in-linear">
            <router-view v-if="!$route.meta.keepAlive"
                         ref="chartView" />
          </transition>

          <!-- <el-collapse-transition>
                  <router-view/>
                </el-collapse-transition> -->

          <!-- <transition name="el-zoom-in-bottom">
                  <router-view/>
                </transition> -->

          <!-- <transition name="fade">
                  <router-view/>
                </transition> -->
        </el-main>
      </el-container>
    </el-container>
    <el-drawer title="notitle"
               :visible.sync="drawer"
               :before-close="handleClose"
               :with-header="false">

      <div class="header">
        <div @click="handleClose"
             class="goback"
             :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">
          <img src="@/assets/container/goback.png"
               alt="">
        </div>

        <div class="right"
             :style="{'backgroundColor': isCustom ? customColor : isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
          <img src="@/assets/container/file.png"
               alt="">

          <div @click="oneDelete"
               class="cleanup">
            <img src="@/assets/container/cleanup.png"
                 alt="">
            <p>一键清除</p>
          </div>
        </div>
      </div>

      <div v-if="isHavePic"
           class="piclistbj">
        <div style="display:flex;justify-content:space-between;">
          <p>已选用资源</p>
          <el-switch style="display: block"
                     v-model="switchFlag"
                     :active-color="isCustom ? customColor : isSimple?'#E27B02':'#185ED3'"
                     @change="openBatchChoose"
                     inactive-text="全选">
          </el-switch>
        </div>
        <div  v-if='filterPicList.length>0' style="color:darkgrey;font-size: 14px;height: 40px;line-height: 40px;">选用图片</div>
        <div class="piclist" v-if='filterPicList.length>0' :style="filterVideoList.length>0?'padding-bottom:10px':''">
          
          <div class="pic"
               v-for="(e,i) in filterPicList"
               @click="chooseImage(e)"
               :key="i">
            <el-image style="width:100px;height:100px;"
                      :src='e.srcW1080 ? e.srcW1080 : e.fileInfo.picW1080 ? e.fileInfo.picW1080 : e.src'
                      v-if="e.type === 'pic'"
                      fit="cover"
                      lazy>
              <!-- :preview-src-list="choosePicSrc" -->
            </el-image>
            <div>
              <div class="delete"
                   v-if="!switchFlag && chooseArr.indexOf(e.id) == -1">
                <img @click.stop="picDelete(i,e.type)"
                     src="@/assets/container/delete.png"
                     alt="">
              </div>
              <!-- <div @click="chooseImage(e)"
                   v-if="switchFlag"
                   class="icon"><i class="el-icon-check"></i></div> -->
            </div>
            <div class="choose"
                 @click.stop="noChooseImage(e.id,i)"
                 v-if="chooseArr.indexOf(e.id) != -1 ">
              <img class="img"
                   :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                   alt="">
              <!-- <div @click="noChooseImage(e.id)"
                   class="icon"><i class="el-icon-close"></i></div> -->
            </div>
          </div>
        </div>
        <div v-if='filterVideoList.length>0' style="color:darkgrey;font-size: 14px;height: 40px;line-height: 40px;">选用视频</div>
        <div class="piclist" v-if='filterVideoList.length>0'>
          
          <div class="pic"
               v-for="(e,i) in filterVideoList"
               @click="chooseImage(e)"
               :key="i">
            <video
                  style="height: 100px"
                  v-if="e.type === 'video'"
                  :src="e.src || e.srcW1080"
                ></video>
            <div>
              <div class="delete"
                   v-if="!switchFlag && chooseArr.indexOf(e.id) == -1">
                <img @click.stop="picDelete(i,e.type)"
                     src="@/assets/container/delete.png"
                     alt="">
              </div>
              <!-- <div @click="chooseImage(e)"
                   v-if="switchFlag"
                   class="icon"><i class="el-icon-check"></i></div> -->
            </div>
            <div class="choose"
                 @click.stop="noChooseImage(e.id,i)"
                 v-if="chooseArr.indexOf(e.id) != -1 ">
              <img class="img"
                   :src="isSimple ? require('@/assets/personpic/simplegou.png') : require('@/assets/personpic/gou.png')"
                   alt="">
              <!-- <div @click="noChooseImage(e.id)"
                   class="icon"><i class="el-icon-close"></i></div> -->
            </div>
          </div>
        </div>

      </div>

      <div v-if="!isHavePic"
           class="piclistbj">
        <p>无选用图片</p>

        <div class="piclist disflex">
          <img height="200px"
               src="@/assets/piclist/nonr.png"
               alt="">
        </div>

      </div>

      <div @click="isSavePic = !isSavePic"
           ref="check"
           v-if="!pushFlag && !downloadFlag"
           class="check">
        <!-- <img v-if="isSavePic"
             src="@/assets/house/checkTrue.png"
             alt=""> -->
        <img v-if="!isSavePic"
             src="@/assets/house/checkFalse.png"
             alt="">
        <img v-if="isSavePic && isSimple"
             src="@/assets/personpic/simplechoosehover.png"
             alt />
        <img v-if="isSavePic && !isSimple"
             src="@/assets/personpic/choosehover.png"
             alt />
        操作完保留选用图片
      </div>

      <div class="drawerbtn">
        <div>
          <div class="btnbj">
            <el-button v-if="powersObj.pictureDownload"
                       @click="downloadClick"
                       class="btt">打包下载</el-button>
          </div>
          <!-- <br> -->
          <!-- <div class="btnbj">
            <el-button v-if="powersObj.pictureShare"
                       @click="chooseShare(0,'system-workgroup','工作圈',0)"
                       class="btt">分享至工作圈</el-button>
          </div> -->
          <!-- <br> -->
          <!-- <div class="btnbj">
            <el-button v-if="powersObj.picturePush"
                       @click="openShow"
                       class="btt">推送</el-button>
          </div> -->
        </div>

        <transition name="el-fade-in-linear">
          <div v-if="downloadFlag"
               class="download"
               @click="closeDownload">
            <div @click.stop
                 style="width:400px;margin:45px auto;">
              <el-input placeholder="请输入打包标题"
                        v-model="downloadTitle">
                <el-button @click.stop="downloadPic"
                           slot="append">打包下载</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="shareFlag"
               class="push"
               @click="shareFlag = false">
            <!-- <div @click.stop
                 style="width:400px;margin:110px auto;">
              <el-input placeholder="请输入分享标题"
                        v-model="shareTitle">
                <el-button @click.stop="sharePic"
                           slot="append">分享</el-button>
              </el-input>
            </div> -->

            <div style="width:430px;margin:30px auto 0;">
              <p>分享至</p>
              <div class="pushbj"
                   :style="{justifyContent:shareList.length == 1 ? 'center' : 'space-between'}">
                <div @click.stop="chooseShare(i,e.template,e.name,e.id)"
                     :class="shareIndex === i? isSimple ? 'pushlist simpleactive' : 'pushlist active':'pushlist'"
                     v-for="(e,i) in shareList"
                     :key="i">
                  {{e.name}}
                  <img v-if="shareIndex === i"
                       src="@/assets/house/checkInside.png"
                       alt="">
                </div>

              </div>

            </div>

          </div>
        </transition>
        <transition name="el-fade-in-linear">
          <div v-if="pushFlag"
               class="push"
               @click="closeShow">
            <div style="width:430px;margin:30px auto 0;">
              <p>推送至</p>
              <div class="pushbj"
                   :style="{justifyContent:pushList.length == 1 ? 'center' : 'space-between'}">
                <div @click.stop="choosePush(i,e.template,e.name,e.id)"
                     :class="pushIndex === i? isSimple ?  'pushlist simpleactive' : 'pushlist active':'pushlist'"
                     v-for="(e,i) in pushList"
                     :key="i">
                  {{e.name}}
                  <img v-if="pushIndex === i"
                       src="@/assets/house/checkInside.png"
                       alt="">
                </div>
                <!-- <div class="pushlist">
                  融媒体平台
                  <img src="@/assets/house/checkInside.png" alt="">
                </div>
                <div class="pushlist">
                  第三方平台
                  <img src="@/assets/house/checkInside.png" alt="">
                </div> -->

              </div>

              <!-- <div @click.stop="pushPic" class="sure">
                确定
              </div> -->
            </div>
          </div>
        </transition>
      </div>
    </el-drawer>
    <el-dialog width="26%"
               :before-close="handleClosePic"
               :visible.sync="mydialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至图片邀约</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               label-width="70px"
               :rules="rules">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
          </el-form-item> -->
        <el-form-item label="标题："
                      prop="name">
          <el-select :remote-method="selectPicTitle"
                     @focus="setMaxWidthPic"
                     @change="myformChange"
                     remote
                     filterable
                     style="width:100%;"
                     v-model="myform.name"
                     placeholder="请选择标题">
            <el-option v-for="(e,i) in picInviteList"
                       :style="{'width': maxWidthPic + 2 + 'px'}"
                       :key="i"
                       :label="e.title"
                       :value="e"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="myform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitPic('myform')">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog width="26%"
               :before-close="dfhandleClosePic"
               :visible.sync="dfdialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至东方网融媒体平台</div>
      </div>
      <el-form :model="dfmyform"
               ref="dfmyform"
               label-width="70px"
               :rules="dfrules">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
          </el-form-item> -->
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="dfmyform.name"></el-input>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="dfmyform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="dfsubmitPic('dfmyform')">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog width="26%"
               :before-close="handleCloseUser"
               :visible.sync="dialogVisibleUser">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至用户</div>
      </div>
      <el-form :model="userForm"
               ref="userForm"
               label-width="100px"
               :rules="userRules">
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="userForm.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择用户："
                      prop="user">
          <!-- multiple -->
          <el-select :remote-method="selectUser"
                     remote
                     v-model="userForm.user"
                     filterable
                     style="width:100%;"
                     placeholder="请选择用户">
            <el-option style="width:100%;"
                       v-for="item in userList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       v-html="'<span style=color:#303030;>'+item.name+'</span>'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="userForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseUser">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitUser('userForm')">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog width="26%"
               :before-close="handleCloseWork"
               :visible.sync="dialogVisibleWork">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>分享至工作圈</div>
      </div>
      <el-form :model="workForm"
               ref="workForm"
               label-width="110px"
               :rules="workRules">
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="workForm.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择工作圈："
                      prop="work">
          <!-- multiple -->
          <el-select :remote-method="selectWork"
                     remote
                     v-model="workForm.work"
                     filterable
                     style="width:100%;"
                     placeholder="请选择工作圈">
            <el-option style="width:100%;"
                       v-for="item in workList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       v-html="'<span style=color:#303030;>'+item.name+'</span>'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="workForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseWork">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitWork('workForm')">提 交</el-button>
      </div>
    </el-dialog>
    <div v-if="isChro"
         ref="jianyi"
         class="jianyi">
      <p>您所使用的浏览器可能影响正常使用，建议使用Chrome和Firefox。</p>
      <div @click="closeJY">关闭</div>
    </div>
    <el-dialog width="26%"
               :before-close="handleCloseLive"
               :visible.sync="dialogVisibleLive">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至直播活动</div>
      </div>
      <el-form :model="liveform"
               ref="liveform"
               label-width="70px"
               :rules="ruleslive">
        <el-form-item label="标题："
                      prop="id">
          <el-select :remote-method="selectPicTitle"
                     @focus="setMaxWidthPic"
                     @change="liveformChange"
                     remote
                     filterable
                     style="width:100%;"
                     v-model="liveform.title"
                     placeholder="请选择标题">
            <el-option v-for="(e,i) in liveList"
                       :style="{'width': maxWidthPic + 2 + 'px'}"
                       :key="i"
                       :label="e.title"
                       :value="e"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="liveform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseLive">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitLive('liveform')">提 交</el-button>
      </div>
    </el-dialog>

<el-dialog
  title="提示"
  :visible.sync="dialogVisibledefinition"
  width="30%"
  :before-close="handleClose">
  <span>请选择下载清晰度!</span>
  <!-- <el-input style="margin-top:10px" v-model="input" placeholder="请输入打包标题"></el-input> -->
  <p style="margin-top:20px">分辨率:
     <el-radio-group v-model="radio">
    <el-radio :label="0">高</el-radio>
    <el-radio :label="1">中</el-radio>
    <el-radio :label="2">原图</el-radio>
    <el-radio :label="3">低</el-radio>
  </el-radio-group>
  </p>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisibledefinition = false">取 消</el-button>
    <el-button type="primary" @click="determine">确 定</el-button>
  </span>
</el-dialog>

<el-dialog
  title="提示：下载消耗积分"
  :visible.sync="downLoadPointFlag"
  width="30%"
  >
  <!-- <el-input style="margin-top:10px" v-model="input" placeholder="请输入打包标题"></el-input> -->
  
  <div style="display:grid;grid-template-columns: 150px 1fr;height: 40px;line-height: 40px;">
    <div>本次下载需消耗积分:</div>
    <div><el-tag>{{ downloadPoints }}</el-tag></div>
  </div>
  <div style="display:grid;grid-template-columns: 150px 1fr;height: 40px;line-height: 40px;">
    <div>当前可用积分:</div>
    <div><el-tag :type="availablePoints-downloadPoints<0?'danger':'success'">{{ availablePoints }}</el-tag></div>
  </div>
  <div v-if="downLoadMessage" style="color:red;font-size: 10px;line-height: 20px;">
    提示：{{ downLoadMessage }}
  </div>
  <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;">
    <span style="color:red;font-size: 10px;line-height: 20px;">注：积分问题请联系孙xx(12354874584)</span>

    <div>
      <el-button @click="downLoadPointFlag = false">取 消</el-button>
      <el-button :disabled="availablePoints-downloadPoints<0" type="primary" @click="checkDownLoadPoint">确 定</el-button>
    </div>
  </span>
</el-dialog>
  </div>
</template>

<script>
// import myelheader from '@/components/myelheader'
import { myelaside, myelheader } from '@/components/index'
import { mapGetters, mapActions } from "vuex";
import { myPictureNeed } from "@/api/pictureNeed";
import { getAppBaseConfig } from "@/api/config";

import { listWorkgroup } from "@/api/workgroup";
import { powersObj } from "@/constants/powers";
import { listAllowPushChannel } from "@/api/pushChannel";
import { listUser } from "@/api/user";
import { getUserSettin, setSystemConfig, setUserSetting, getUserSetting } from '@/api/config'
import { addPicturePackage,searchPicturePackageInfo } from "@/api/picturePackage";
import { getPictures } from "@/api/picture";
import { getVideos } from "@/api/video";

import { myActivityLive } from "@/api/activityLive";
import { picPrefix } from "@/constants/piccommon";

import getIsSimple from '@/constants/simple'

export default {
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isPointsEnable:'',
      filterVideoList: [],
      filterPicList:[],
      downloadPoints:50,
      availablePoints: 60,
      downLoadMessage:'',
      lockPoint:60,
      dialogVisibledefinition: false,
      downLoadPointFlag:false,
      picPrefix,
      getIsSimple,
      simple: true,
      // isCustom:false,
      // customColor:'',
      // custom:'',
      radio:0,
      isRouterAlive: true,                    //控制视图是否显示的变量
      input:'',
      hearerbjSimple: require('@/assets/myheader/simpleheaderbj.png'),
      hearerbj: require('@/assets/myheader/headerbg.png'),
      xgbj: require('@/assets/custom/xg-head.png'),
      wcbj: require('@/assets/custom/wc-head.png'),

      powersObj,  //权限

      //判断浏览器
      isChro: false,

      isSavePic: false,
      //推送到用户
      dialogVisibleUser: false,

      userForm: {
        name: "",
        user: "",
        createUid: this.createUid,
        note: ""
      },
      userRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        user: [{ required: true, message: "请选择用户", trigger: "change" }],
      },
      userList: [],

      //分享列表
      shareList: [{
        template: 'system-workgroup',
        name: '工作圈',
        id: 0
      }],
      shareIndex: 0,

      //分享到工作圈
      dialogVisibleWork: false,
      workForm: {
        name: "",
        work: "",
        createUid: this.createUid,
        note: ""
      },
      workRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        work: [{ required: true, message: "请选择工作圈", trigger: "change" }],
      },
      workList: [],

      //推送列表
      pushList: [],
      pushIndex: 0,
      //推送至图片邀约
      mydialogVisible: false,
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ''
      },
      rules: {
        name: [{ required: true, message: "请填写标题", trigger: "change" }],
      },
      picInviteList: [],

      //推送至直播
      dialogVisibleLive: false,
      liveform: {
        title: "",
        note: "",
        createUid: this.createUid,
        id: ''
      },
      ruleslive: {
        id: [{ required: true, message: "请选择标题", trigger: "change" }],
      },
      liveList: [],

      //推送至东方
      dfdialogVisible: false,
      dfmyform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ''
      },
      dfrules: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }],
      },

      downloadFlag: false,
      shareFlag: false,
      pushFlag: false,
      downloadTitle: '',
      shareTitle: '',
      pushTitle: '',
      isHavePic: true,
      choosePic: [],
      choosePicSrc: [],
      hidasideList: [
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-housewhite.png') : require('@/assets/myaside/wc-housewhite.png') : require('@/assets/myaside/housewhite.png'),
          url: '/desktop/contributor',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-house.png') : require('@/assets/myaside/wc-house.png') : require('@/assets/myaside/house.png'),
          text: '工作桌面',
          field: 'desktopAuthor'
        },

        // {
        //   src: require('@/assets/myaside/housewhite.png'),
        //   url: '/desktop/manager',
        //   clicksrc: require('@/assets/myaside/house.png'),
        //   text: '管工作桌面',
        //   field: 'Notdeveloped'
        // },
        // {
        //   src: require('@/assets/myaside/housewhite.png'),
        //   url: '/desktop/editor',
        //   clicksrc: require('@/assets/myaside/house.png'),
        //   text: '用工作桌面',
        //   field: 'Notdeveloped'
        // },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-personwhite.png') : require('@/assets/myaside/wc-personwhite.png') : require('@/assets/myaside/personwhite.png'),
          url: '/myLib/myAtlas',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-person.png') : require('@/assets/myaside/wc-person.png') : require('@/assets/myaside/person.png'),
          text: '个人资源库',
          field: 'allowMyGallery'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-picwhite.png') : require('@/assets/myaside/wc-picwhite.png') : require('@/assets/myaside/picwhite.png'),
          url: '/pictureCenter',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-pic.png') : require('@/assets/myaside/wc-pic.png') : require('@/assets/myaside/pic.png'),
          text: '媒资检索',
          field: 'allowGalleryCenter'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-delwhite.png') : require('@/assets/myaside/wc-delwhite.png') : require('@/assets/myaside/delwhite.png'),
          url: '/config/basic',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-del.png') : require('@/assets/myaside/wc-del.png') : require('@/assets/myaside/del.png'),
          text: '回收站',
          field: 'allowRecycleBin'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-headwhite.png') : require('@/assets/myaside/wc-headwhite.png') : require('@/assets/myaside/headwhite.png'),
          url: '/digitalCenter/dataAnalysis',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-head.png') : require('@/assets/myaside/wc-head.png') : require('@/assets/myaside/head.png'),
          text: '数智中心',
          field: 'setup'
        },

        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-platwhite.png') : require('@/assets/myaside/wc-platwhite.png') : require('@/assets/myaside/platwhite.png'),
          url: '/config/platform',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-plat.png') : require('@/assets/myaside/wc-plat.png') : require('@/assets/myaside/plat.png'),
          text: '平台运维',
          field: 'setup'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-setupwhite.png') : require('@/assets/myaside/wc-setupwhite.png') : require('@/assets/myaside/setupwhite.png'),
          url: '/config/basic',
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-setup.png') : require('@/assets/myaside/wc-setup.png') : require('@/assets/myaside/setup.png'),
          text: '系统设置',
          field: 'setup'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-setupwhite.png') : require('@/assets/myaside/wc-setupwhite.png') : require('@/assets/myaside/setupwhite.png'),
          clicksrc: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-setup.png') : require('@/assets/myaside/wc-setup.png') : require('@/assets/myaside/setup.png'),
          url: '/checkCenter',
          text: '资源管理',
          field: 'auditEnabled'
        },

      ],
      asideList: [
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-house.png') : require('@/assets/myaside/wc-house.png') : require('@/assets/myaside/house.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-housewhite.png') : require('@/assets/myaside/wc-housewhite.png') : require('@/assets/myaside/housewhite.png'),
          url: '/desktop/contributor',
          text: '工作桌面',
          field: 'desktopAuthor'
        },
        // {
        //   src: require('@/assets/myaside/house.png'),
        //   srcw: require('@/assets/myaside/housewhite.png'),
        //   url: '/desktop/manager',
        //   text: '管工作桌面',
        //   field: 'Notdeveloped'
        // },
        // {
        //   src: require('@/assets/myaside/house.png'),
        //   srcw: require('@/assets/myaside/housewhite.png'),
        //   url: '/desktop/editor',
        //   text: '用工作桌面',
        //   field: 'Notdeveloped'
        // },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-person.png') : require('@/assets/myaside/wc-person.png') :  require('@/assets/myaside/person.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-personwhite.png') : require('@/assets/myaside/wc-personwhite.png') :require('@/assets/myaside/personwhite.png'),
          url: '/myLib/myMediaAll',
          text: '个人资源库',
          // 111
          children: [
            // {
            //   text: '我的资源集',
            //   url: '/myLib/myAtlas',
            //   field: 'allowMyGallery'
            // },
            {
              text: '我的资源集',
              url: '/myLib/myMediaAll',
              field: 'allowMyGallery',
              isAuditEnabled:false,
            },
            {
              text: '审核通过',
              url: '/myLib/checkPass',
              field: 'allowMyGallery',
              isAuditEnabled:true,
            },
            


            
            // {
            //   text: '我的图片',
            //   url: '/myLib/myPic',
            //   field: 'allowMyGallery'
            // },
            
            // {
            //   text: '我的视频',
            //   url: '/myLib/myVideo',
            //   field: 'allowMyGallery'
            // },
            
            {
              text: '已送审',
              url: '/myLib/sendCheck',
              field: 'allowMyGallery',
              isAuditEnabled:true,
            },
            // {
            //   text: '待送审',
            //   url: '/myLib/waitSendCheck',
            //   field: 'allowMyGallery'
            // },
            {
              text: '未通过',
              url: '/myLib/noPass',
              field: 'allowMyGallery',
              isAuditEnabled:true,
            },
            // {
            //   text: '未整理资源',
            //   url: '/myLib/unClutteredPicture',
            //   field: 'browseUnPicture'
            // },
          ],
          field: 'allowMyGallery'
        },
        
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-pic.png') : require('@/assets/myaside/wc-pic.png') : require('@/assets/myaside/pic.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-picwhite.png') : require('@/assets/myaside/wc-picwhite.png') : require('@/assets/myaside/picwhite.png'),
          url: '/pictureCenter',
          text: '媒资检索',
          field: 'allowGalleryCenter'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-del.png') : require('@/assets/myaside/wc-del.png') : require('@/assets/myaside/del.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-delwhite.png') : require('@/assets/myaside/wc-delwhite.png') : require('@/assets/myaside/delwhite.png'),
          url: '/recyclebin/pic',
          text: '回收站',
          field: 'allowRecycleBin',
          children: [
            {
              text: '图片回收站',
              url: '/recyclebin/pic',
              field: 'allowRecycleBin'
            },{
              text: '视频回收站',
              url: '/recyclebin/video',
              field: 'allowRecycleBin'
            }
            // , {
            //   text: '文档回收站',
            //   url: '/recyclebin/word',
            //   field: 'allowRecycleBin'
            // }
          ]
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-head.png') : require('@/assets/myaside/wc-head.png') : require('@/assets/myaside/head.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-headwhite.png') : require('@/assets/myaside/wc-headwhite.png') : require('@/assets/myaside/headwhite.png'),
          url: '/digitalCenter/dataAnalysis',
          text: '数智中心',
          children: [
            {
              text: '数据分析',
              url: '/digitalCenter/dataAnalysis',
              field: 'dataAnalysis'
            },
            {
              text: '资源人物管理',
              url: '/myLib/peopleManage',
              field: 'myFace'
            },
            {
              text: '智能节点管理',
              url: '/digitalCenter/smartCenter',
              field: 'manageIntelligentNode'
            },
            {
              text: '下载日志记录',
              url: '/digitalCenter/downloadLog',
              field: 'resourceLogCenter'
            },
            {
              text: '数据统计',
              url: '/digitalCenter/dataStatic',
              field: 'dataAnalysis'
            },
            {
              text: '排名统计',
              url: '/digitalCenter/dataSort',
              field: 'dataAnalysis'
            },
            {
              text: '标签统计',
              url: '/digitalCenter/datalabelclass',
              field: 'dataAnalysis'
            },
          ],
          field: 'allowAiCenter'
        },


        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-plat.png') : require('@/assets/myaside/wc-plat.png') : require('@/assets/myaside/plat.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-platwhite.png') : require('@/assets/myaside/wc-platwhite.png') : require('@/assets/myaside/platwhite.png'),
          url: '/config/platform',
          text: '平台运维',
          children: [
            {
              text: '系统日志',
              url: '/config/journalManage',
              field: 'systemLogs'
            },
            {
              text: '运维操作',
              url: '/config/platform',
              field: 'operationCommand'
            },
            // {
            //   text: '共享盘管理',
            //   url: '/operationManage/shareManage',
            //   field: 'manageNas'
            // },
            // {
            //   text: '第三方接入',
            //   url: '/operationManage/thirdAccess',
            //   field: 'manageThirdPartyAccess'
            // },
            // {
            //   text: '回调管理',
            //   url: '/operationManage/callBack',
            //   field: 'justAdmin'
            // },
          ],
          field: 'allowOperationCenter'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-setup.png') : require('@/assets/myaside/wc-setup.png') : require('@/assets/myaside/setup.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-setupwhite.png') : require('@/assets/myaside/wc-setupwhite.png') : require('@/assets/myaside/setupwhite.png'),
          text: '系统设置',
          url: '/config/basic',
          children: [
            // {
            //   text:'账号密码',
            //   url:'/contributorsetup'
            // },
            // {
            //   text:'基础设置',
            //   url:'/contributorbasicsetup'
            // },
            {
              text: '基础设置',
              url: '/config/basic',
              field: 'baseConfig'
            },
            {
              text: '安全配置',
              url: '/config/safey',
              field: 'securityConfig'
            },

            {
              text: '资源库管理',
              url: '/config/picManage',
              field: 'libConfig'
            },
            {
              text: '角色配置',
              url: '/config/roleManage',
              field: 'roleConfig'
            },
            {
              text: '用户管理',
              url: '/config/userManage',
              field: 'userConfig'
            },
            {
              text: '部门管理',
              url: '/config/departmentManage',
              field: 'departmentEnabled'
            },
            
            // {
            //   text: '系统日志',
            //   url: '/config/journalManage',
            //   field: 'systemLogs'
            // },
            // {
            //   text: '平台运维',
            //   url: '/config/platform',
            //   field: 'userConfig'
            // },
            // {
            //   text: '站点管理',
            //   url: '/config/site',
            //   field: 'websiteConfig'
            // },
            {
              text: '标签管理',
              url: '/config/labelManage',
              field: 'customLabelConfig'
            },
            {
              text: '分类管理',
              url: '/config/classificationManage',
              field: 'classifyEnabled'
            },
            {
              text: '评级管理',
              url: '/config/rateManage',
              field: 'rateEnabled'
            },
            {
              text: '工作圈管理',
              url: '/config/workGroup',
              field: 'justAdmin'
            },
            // {
            //   text: '单点登录配置',
            //   url: '/config/oneLogin',
            //   field: 'ssoConfig'
            // },
            // {
            //   text: '推送渠道管理',
            //   url: '/config/pushChannelManage',
            //   field: 'pushConfig'
            // },
            // {
            //   text: '活动主题管理',
            //   url: '/config/activityThemeManage',
            //   field: 'activityThemeConfig'
            // },
            // {
            //   text: '文本与协议管理',
            //   url: '/config/appTextConfigManage',
            //   field: 'textConfig'
            // },

            // {
            //   text:'常用信息',
            //   url:'/contributorpersonsetup'
            // },
          ],
          field: 'setup'
        },
        {
          src: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-pic.png') : require('@/assets/myaside/wc-pic.png') : require('@/assets/myaside/pic.png'),
          srcw: this.isCustom ? this.custom == 'xugong' ?  require('@/assets/myaside/xg-picwhite.png') : require('@/assets/myaside/wc-picwhite.png') : require('@/assets/myaside/picwhite.png'),
          url: '/checkCenter',
          text: '资源管理',
          field: 'auditEnabled'
        },


      ],
      // mytest:this.$store.state.user.test,
      isAside: true,
      transitionName: 'slide-left',
      headerClass: '0',
      i: 0,
      drawer: this.$store.state.user.drawer,
      loveList: this.$store.state.user.loveList,

      template: '',
      pushChannelId: '',

      //option最大宽度
      maxWidthPic: 0,

      chooseArr: [], //已选中的数组
      chooseAll: '',  //全选图片
      switchFlag: false,  //switch开关


      //判断下载图片清晰度
      thumb:'original',
    }
  },
  watch: {
    '$route'(to, from) {
      console.log('我变了');
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      // if (!localStorage.getItem('isAuditEnabled')) {
      //     // 111
      //     this.asideList = this.asideList.filter((ele) => ele.field !== 'auditEnabled')
      //     this.asideList.forEach((ele) => {
      //       if (ele.url == '/myLib/myMediaAll') {
      //         ele.children  = ele.children.filter((ele) => ele.field !== 'baseConfig')
      //         // console.log('arr---------------',arr);
      //       }
      //     })

      // }
    },
    $route: {
      handler: function (to, from) {
        console.log('我变了');
        let isAuditEnabled = localStorage.getItem('isAuditEnabled')
        if (isAuditEnabled!==null) {
          console.log(1111, isAuditEnabled);
          if (isAuditEnabled=='false') {
            this.asideList = this.asideList.filter((ele) => ele.field !== 'auditEnabled')
            this.asideList.forEach((ele) => {
              if (ele.url == '/myLib/myMediaAll') {
                ele.children  = ele.children.filter((ele) => !ele.isAuditEnabled)
                // console.log('arr---------------',arr);
              }
            })
          }
        }
      },
      immediate:true
    },
    '$store.state.user.drawer' (data) {
      this.drawer = data
      if (this.drawer) {
        this.openBatchChoose()
      }
      this.switchFlag = false
      let picLoveString = sessionStorage.getItem("picLove");
      if (picLoveString) {
        this.choosePic = JSON.parse(picLoveString)
        for (let i = 0; i < this.choosePic.length; i++) {
          try {
            if (this.choosePic[i].resourceId) {
              this.choosePic[i].id = this.choosePic[i].resourceId
            }
          } catch (error) {

          }
        }
        // console.log(this.choosePic)
        if (!this.choosePic) {
          this.isHavePic = false
        } else {
          this.isHavePic = true
        }
      } else {
        this.choosePic = []
        this.isHavePic = false
      }

    },
    '$store.state.user.loveList' (data) {
      this.loveList = data
    },
    choosePic: {
      handler: function (newV, oldV) {
        console.log('-----------new', newV);
        this.filterPicList = newV.filter((ele)=>ele.type=='pic')
        this.filterVideoList = newV.filter((ele)=>ele.type=='video')
      },immediate:true
    }
  },
  computed: {
    ...mapGetters(["roleCode"]),
    ...mapGetters(["createUid"]),
    ...mapGetters(["powers"]),

  },
  components: {
    'myelaside': myelaside,
    'myelheader': myelheader
  },
  methods: {
    ...mapActions(["setDrawer"]),
    ...mapActions(["setLoveList"]),
    myformChange (val) {
      console.log(val);
      this.myform.name = val.title;
      this.myform.id = val.id;
    },

    getSimple () {
      getIsSimple().then(res => {
        // if(res.isCustom){
        //     this.isCustom = res.isCustom
        //     this.customColor = res.customColor
        //     this.custom = res.custom
        //   }else{
        //     this.isCustom = false
        //     this.customColor = res.customColor
        //     this.custom = res.custom
        //   }
        if (typeof (res.isSimple) !== "undefined") {
          this.simple = res.isSimple
        } else {
          this.simple = true
        }
      })
    },

    //打开推送内容
    openShow () {
      if (this.chooseArr.length <= 0) {
        this.$message.warning('请选择图片！')
        return false;
      }
      // this.$refs.check.style.zIndex = 0
      this.pushFlag = true
      this.listAllowPushChannelAsync()
    },

    //关闭推送内容
    closeShow () {
      // this.$refs.check.style.zIndex = 1000
      this.pushFlag = false
    },

    //邀约名筛选
    selectPicTitle (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query }
        this.listPictureNeedAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20 }
        this.listPictureNeedAsync(dataExa)
      }
    },

    //工作圈筛选
    selectWork (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query }
        this.listWorkgroupAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20 }
        this.listWorkgroupAsync(dataExa)
      }
    },

    //用户名筛选
    selectUser (query) {
      let dataExa
      if (query !== '') {
        dataExa = { userType: 0, keyword: query }
        this.listUserAsync(dataExa)
      } else {
        dataExa = { userType: 0 }
        this.listUserAsync(dataExa)
      }
    },

    //设置option最大宽度
    setMaxWidthPic (val) {
      this.maxWidthPic = val.srcElement.clientWidth
    },

    closeJY () {
      this.$refs.jianyi.style.display = 'none'
      sessionStorage.setItem('isChro', true)
    },
    myBrowser () {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1;
      if (isOpera) { //判断是否Opera浏览器
        return false;
      }
      ;
      if (userAgent.indexOf("Firefox") > -1) { //判断是否Firefox浏览器
        return true;
      }
      ;
      if (userAgent.indexOf("Chrome") > -1) {
        return true;
      }
      ;
      if (userAgent.indexOf("Safari") > -1) { //判断是否Safari浏览器
        return false;
      }
      ;
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { //判断是否IE浏览器
        return false;
      }
      ;
    },

    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      })
    },

    comPic(val, tt) {
      // console.log(this.filterPicList);
      // console.log(this.filterVideoList);
      // console.log(this.chooseArr);
      const filterPicList = this.filterPicList.filter(item=>this.chooseArr.includes(item.id))
      const filterVideoList = this.filterVideoList.filter(item => this.chooseArr.includes(item.id))
      console.log(filterPicList);
      console.log(filterVideoList);
      console.log(val,tt)
      let choosePicMsg = {
        createUid: this.createUid,
        packageType: val,
        pictureCount: filterPicList.length,
        pictureIds: '',
        videoIds: '',
        videoCount:filterVideoList.length, 
        targetUid: tt.user || 0,
        title: tt.name || tt.title || tt,
        pushConfig: JSON.stringify({ pushChannelId: this.pushChannelId, pictureNeedId: tt.id, note: tt.note }) || '',
        downloadConfig: JSON.stringify({ thumb:this.thumb }) || ''
      }
      let filterPicIds = [];
      filterPicList.forEach((ele) => {
        filterPicIds.push(ele.id) 
      })
      let filterVideoIds = [];
      filterVideoList.forEach((ele) => {
        filterVideoIds.push(ele.id) 
      })
      choosePicMsg.pictureIds = filterPicIds.join(',')

      choosePicMsg.videoIds = filterVideoIds.join(',')
      // console.log(choosePicMsg, this.choosePic, this.chooseArr);
      console.log(choosePicMsg);
      // console.log(this.chooseArr, this.switchFlag);
      // return
      this.addPicturePackageAsync(choosePicMsg)

      if (!this.isSavePic) {
        if (this.switchFlag) {
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.loveList = []
          this.setLoveList(this.loveList)
        } else {
          let picLoveList = JSON.parse(sessionStorage.getItem("picLove"))
          for (let i = 0; i < picLoveList.length; i++) {
            try {
              if (picLoveList[i].resourceId) {
                picLoveList[i].id = picLoveList[i].resourceId
              }
            } catch (error) {
            }
          }
          for (let k = 0; k < this.chooseArr.length; k++) {
            for (let j = 0; j < picLoveList.length; j++) {
              if (this.chooseArr[k] == picLoveList[j].id) {
                picLoveList.splice(j, 1)
              }
            }
          }
          let loveList = []
          for (let m = 0; m < picLoveList.length; m++) {
            loveList.push(picLoveList[m].id)
          }
          this.setLoveList(loveList)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveList));
          let idsInfo = []
          for (let k = 0; k < picLoveList.length; k++) {
            idsInfo.push({
              id: picLoveList[k].id,
              type:picLoveList[k].type
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', idsInfo)
        }

      }

      this.chooseArr = []
      this.switchFlag = false
      this.isSavePic = false
    },
    saveOrDel () {
      console.log(this.isSavePic, this.switchFlag);
      if (!this.isSavePic) {
        if (this.switchFlag || false) {
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.loveList = []
          this.setLoveList(this.loveList)
        } else {
          let picLoveList = JSON.parse(sessionStorage.getItem("picLove"))
          for (let i = 0; i < picLoveList.length; i++) {
            try {
              if (picLoveList[i].resourceId) {
                picLoveList[i].id = picLoveList[i].resourceId
              }
            } catch (error) {

            }

          }
          for (let k = 0; k < this.chooseArr.length; k++) {
            for (let j = 0; j < picLoveList.length; j++) {
              if (this.chooseArr[k] == picLoveList[j].id) {
                picLoveList.splice(j, 1)
              }
            }
          }
          let loveList = []
          for (let m = 0; m < picLoveList.length; m++) {
            loveList.push(picLoveList[m].id)
          }
          this.setLoveList(loveList)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveList));
          let idsInfo = []
          for (let k = 0; k < picLoveList.length; k++) {
            idsInfo.push({
              id: picLoveList[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', idsInfo)
        }

      }
    },
    async getPicturesAsync () {
      // let {status,data} = await
    },
    //图片包操作
    //推送
    pushPic (name) {
      // console.log(this.template);
      // return
      if (this.isHavePic) {
        if (this.template === "picture-website") {
          this.handleClose()
          // this.saveOrDel()
          this.$router.push({
            path: '/shareAndPush/push/show',
            query: {
              isSavePic: this.isSavePic,
              name: name,
              isDrawer: !this.switchFlag ? false : true,
              isSwitch: this.switchFlag,
              pushChannelId: this.pushChannelId,
              isUseActivity: true
            }
          })

        } else if (this.template === "routersoft-qms") {
          this.handleClose()
          this.$router.push({
            path: '/shareAndPush/push/qms',
            query: {
              isSavePic: this.isSavePic,
              name: name,
              isDrawer: !this.switchFlag ? false : true,
              isSwitch: this.switchFlag,
              pushChannelId: this.pushChannelId
            }
          })
        } else if (this.template === "routersoft-rmt" || this.template === "routersoft-mcp") {
          this.handleClose()
          this.$router.push({
            path: '/shareAndPush/push/mcp',
            query: {
              isSavePic: this.isSavePic,
              name: name,
              isDrawer: !this.switchFlag ? false : true,
              isSwitch: this.switchFlag,
              pushChannelId: this.pushChannelId
            }
          })
        } else if (this.template === 'picture-need' || this.template === 'system-picture-need') {
          this.mydialogVisible = true
          this.listPictureNeedAsync({
            page: 0,
            pageSize: 20
          })
        } else if (this.template === 'picture-user') {
          this.dialogVisibleUser = true
          this.listUserAsync({ userType: 0 })
        } else if (this.template === "eastnet-mc") {
          this.dfdialogVisible = true

        } else if (this.template === "activity-live") {
          this.dialogVisibleLive = true
          this.myActivityLiveAsync({page:0,pageSize:20})
        }



      } else {
        this.$message.error("请添加选用图片！")
      }
    },

    //直播关闭
    handleCloseLive () {
      this.$refs['liveform'].resetFields();

      this.dialogVisibleLive = false;

    },

    //直播名筛选
    selectPicTitle (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query }
        this.myActivityLiveAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20 }
        this.myActivityLiveAsync(dataExa)
      }
    },
    //直播选择
    liveformChange (val) {
      this.liveform.title = val.title;
      this.liveform.id = val.id;
    },

    //获取我的直播
    async myActivityLiveAsync (val) {
      let { status, data, message, errors } = await myActivityLive(val);
      if (status) {
        console.log(data);
        this.liveList = data
        if(this.liveList.length > 0){
          this.liveform.id = this.liveList[0].id
          this.liveform.title = this.liveList[0].title
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //直播推送
    submitLive (form) {
      this.$refs[form].validate(valid => {
        if (valid) {

          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'push',
            pictureCount: this.choosePic.length,
            pictureIds:'',
            title: this.liveform.title,
            pushConfig: JSON.stringify({ pushChannelId: 'live',activityLiveId:this.liveform.id, note: this.liveform.note }) || ''
          }
          if (!this.switchFlag) {
            for (let i = 0; i < this.choosePic.length; i++) {
              if (i === this.choosePic.length - 1) {
                choosePicMsg.pictureIds += this.choosePic[i].id
              } else {
                choosePicMsg.pictureIds += this.choosePic[i].id + ','
              }
            }
          } else {
            choosePicMsg.pictureIds = this.chooseArr.join(',')
          }

          this.addPicturePackageAsync(choosePicMsg)
          if (!this.isSavePic) {
            this.choosePic = []
            this.isHavePic = false
            if (!this.switchFlag) {
              let allLovePic = JSON.parse(sessionStorage.getItem("picLove"));
              let chooseLovePic = JSON.parse(sessionStorage.getItem("chooseArr"));
              allLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });
              chooseLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });

              let nowLovePic = allLovePic
              for (let i = 0; i < allLovePic.length; i++) {
                for (let j = 0; j < chooseLovePic.length; j++) {
                  if (chooseLovePic[j].id == allLovePic[i].id) {
                    nowLovePic.splice(i, 1)
                  }
                }
              }
              let idsInfo = []
              for (let k = 0; k < nowLovePic.length; k++) {
                idsInfo.push({
                  id: nowLovePic[k].id,
                })
              }
              this.setLoveList(nowLovePic)
              sessionStorage.setItem("picLove", JSON.stringify(nowLovePic));
              this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
            } else {
              sessionStorage.removeItem("picLove");
              this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
            }
            this.loveList = []
            this.setLoveList(this.loveList)
            this.isSavePic = false
          }


          this.dialogVisibleLive = false
          this.setDrawer(false)
          setTimeout(() => {
            this.$router.push('/shareAndPush/myPush')
          }, 1500);
          this.$nextTick(() => {
            this.pushFlag = false
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


    //分享
    sharePic (name) {
      if (this.isHavePic) {
        if (this.template === 'system-workgroup') {
          this.dialogVisibleWork = true
          this.listWorkgroupAsync()
        }

      } else {
        this.$message.error("请添加选用图片！")
      }
    },


    //分享
    // sharePic () {
    //   if (this.isHavePic) {
    //     if (this.shareFlag) {
    //       if (this.shareTitle == "") {
    //         this.$message.error("请输入标题！")
    //       } else {
    //         this.comPic('share', this.shareTitle)
    //         this.shareFlag = false
    //         this.setDrawer(false)
    //         this.$router.push('/shareAndPush/myShare')
    //       }
    //     }
    //   } else {
    //     this.$message.error("请添加选用图片！")
    //   }

    // },
    //确定
    checkDownLoadPoint() {
      this.downLoadPointFlag = false;
      this.downloadFlag = true
    },
    determine(){
      if(this.radio==0){
        this.thumb = 'high'
        this.comPic('download', this.downloadTitle)
        this.downloadFlag = false
        this.setDrawer(false)
        this.$router.push('/shareAndPush/myDownload')
      }else if(this.radio==1){
        this.thumb = 'middle'
        this.comPic('download', this.downloadTitle)
        this.downloadFlag = false
        this.setDrawer(false)
        this.$router.push('/shareAndPush/myDownload')
      }else if(this.radio==2){
        this.thumb = 'original'
        this.comPic('download', this.downloadTitle)
        this.downloadFlag = false
        this.setDrawer(false)
        this.$router.push('/shareAndPush/myDownload')
      }else if(this.radio==3){
        this.thumb = 'small'
        this.comPic('download', this.downloadTitle)
        this.downloadFlag = false
        this.setDrawer(false)
        this.$router.push('/shareAndPush/myDownload')
      }
        this.dialogVisibledefinition=false
    },
    //打包下载
    downloadPic () {
      this.dialogVisibledefinition=true
      if (this.isHavePic) {
        if (this.downloadFlag) {
          if (this.downloadTitle == "") {
            this.$message.error("请输入标题！")
          }
        }
      } else {
        this.$message.error("请添加选用图片！")
      }
    },

    //推送选择
    choosePush (i, t, name, id) {
      this.pushIndex = i
      this.template = t
      this.pushChannelId = id
      this.pushPic(name)

    },

    //下载选择
    async downloadClick () {
      if (this.chooseArr.length <= 0) {
        this.$message.warning('请选择下载资源！')
        return false;
      }
        if (this.chooseArr.length >= 100) {
            this.$message.warning('单次打包下载数量不超过100张！')
            return false;
        }

      // this.$refs.check.style.zIndex = 0
      // console.log('this.isPointsEnable---------',this.isPointsEnable);
      if (this.isPointsEnable == 'true') {
          let choosePicMsg = {
          createUid: this.createUid,
          packageType: 'download',
          pictureCount: this.filterPicList.length,
          pictureIds: '',
          videoIds: '',
          videoCount:this.filterVideoList.length, 
          // targetUid: tt.user || 0,
          // title: tt.name || tt.title || tt,
          // pushConfig: JSON.stringify({ pushChannelId: this.pushChannelId, pictureNeedId: tt.id, note: tt.note }) || '',
          downloadConfig: JSON.stringify({ thumb:this.thumb }) || ''
        }
        let filterPicIds = [];
        this.filterPicList.forEach((ele) => {
          filterPicIds.push(ele.id) 
        })
        let filterVideoIds = [];
        this.filterVideoList.forEach((ele) => {
          filterVideoIds.push(ele.id) 
        })
        choosePicMsg.pictureIds = filterPicIds.join(',')

        choosePicMsg.videoIds = filterVideoIds.join(',')
        let {status,data,message} = await searchPicturePackageInfo(choosePicMsg)
        if (status) {
          this.downLoadPointFlag = true
          this.availablePoints = data.availablePoints
          this.downloadPoints = data.downloadPoints
          this.downLoadMessage = data.message
        } else {
          this.$message.error(message)
        }
      } else {
        this.downloadFlag = true
      }
    },

    //关闭打包下载
    closeDownload () {
      // this.$refs.check.style.zIndex = 10
      this.downloadFlag = false
    },

    //分享选择
    chooseShare (i, t, name, id) {
      if (this.chooseArr.length <= 0) {
        this.$message.warning('请选择图片！')
        return false;
      }
      this.shareIndex = i
      this.template = t
      this.pushChannelId = id
      this.sharePic(name)

    },

    handleCloseWork () {
      this.$refs['workForm'].resetFields();

      this.dialogVisibleWork = false
    },

    //东方网融媒体平台关闭
    dfhandleClosePic () {
      this.$refs['dfmyform'].resetFields();

      this.dfdialogVisible = false;

    },



    handleClosePic () {
      this.myform = {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ''
      }
      this.listPictureNeedAsync({
        page: 0,
        pageSize: 20
      })
      this.mydialogVisible = false;

      // this.clearData()
    },

    handleCloseUser () {
      this.dialogVisibleUser = false;
    },
    //东方推送
    dfsubmitPic (form) {
      this.$refs[form].validate(valid => {
        if (valid) {

          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'push',
            pictureCount: this.choosePic.length,
            pictureIds: '',
            targetUid: 0,
            title: this.dfmyform.name,
            pushConfig: JSON.stringify({ pushChannelId: this.pushChannelId, note: this.dfmyform.note }) || ''
          }
          if (!this.switchFlag) {
            for (let i = 0; i < this.choosePic.length; i++) {
              if (i === this.choosePic.length - 1) {
                choosePicMsg.pictureIds += this.choosePic[i].id
              } else {
                choosePicMsg.pictureIds += this.choosePic[i].id + ','
              }
            }
          } else {
            choosePicMsg.pictureIds = this.chooseArr.join(',')
          }

          this.addPicturePackageAsync(choosePicMsg)
          if (!this.isSavePic) {
            this.choosePic = []
            this.isHavePic = false
            if (!this.switchFlag) {
              let allLovePic = JSON.parse(sessionStorage.getItem("picLove"));
              let chooseLovePic = JSON.parse(sessionStorage.getItem("chooseArr"));
              allLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });
              chooseLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });

              let nowLovePic = allLovePic
              for (let i = 0; i < allLovePic.length; i++) {
                for (let j = 0; j < chooseLovePic.length; j++) {
                  if (chooseLovePic[j].id == allLovePic[i].id) {
                    nowLovePic.splice(i, 1)
                  }
                }
              }
              let idsInfo = []
              for (let k = 0; k < nowLovePic.length; k++) {
                idsInfo.push({
                  id: nowLovePic[k].id,
                })
              }
              this.setLoveList(nowLovePic)
              sessionStorage.setItem("picLove", JSON.stringify(nowLovePic));
              this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
            } else {
              sessionStorage.removeItem("picLove");
              this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
            }
            this.loveList = []
            this.setLoveList(this.loveList)
            this.isSavePic = false
          }


          this.dfdialogVisible = false
          this.setDrawer(false)
          setTimeout(() => {
            this.$router.push('/shareAndPush/myPush')
          }, 1500);
          this.$nextTick(() => {
            this.pushFlag = false
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //图片邀约
    submitPic (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          for (let i = 0; i < this.picInviteList.length; i++) {
            if (this.picInviteList[i].title == this.myform.name) {
              this.myform.id = this.picInviteList[i].id
            }
          }
          this.comPic('push', this.myform)
          this.mydialogVisible = false
          this.setDrawer(false)
          this.$router.push('/shareAndPush/myPush')
          this.$nextTick(() => {
            this.pushFlag = false
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 推送到用户
    submitUser (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.comPic('push', this.userForm)
          this.dialogVisibleUser = false
          this.setDrawer(false)
          this.$router.push('/shareAndPush/myPush')
          this.$nextTick(() => {
            this.pushFlag = false
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //分享到工作圈
    submitWork (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'share',
            pictureCount: this.chooseArr.length,
            pictureIds: '',
            targetUid: 0,
            targetWorkgroupId: this.workForm.work,
            title: this.workForm.name,
            shareConfig: JSON.stringify({ pushChannelId: this.pushChannelId, note: this.workForm.note })
          }
          // if (!this.switchFlag) {
          //   for (let i = 0; i < this.choosePic.length; i++) {
          //     if (i === this.choosePic.length - 1) {
          //       choosePicMsg.pictureIds += this.choosePic[i].id
          //     } else {
          //       choosePicMsg.pictureIds += this.choosePic[i].id + ','
          //     }
          //   }
          // } else {
          choosePicMsg.pictureIds = this.chooseArr.join(',')
          // }
          // console.log(choosePicMsg);
          // return
          this.addPicturePackageAsync(choosePicMsg)
          if (!this.isSavePic) {
            this.choosePic = []
            this.isHavePic = false
            if (!this.switchFlag) {
              let allLovePic = JSON.parse(sessionStorage.getItem("picLove"));
              let chooseLovePic = JSON.parse(sessionStorage.getItem("chooseArr"));
              allLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });
              chooseLovePic.forEach(item => {
                try {
                  item.id = item.resourceId
                } catch (error) {
                }
              });

              let nowLovePic = allLovePic
              for (let i = 0; i < allLovePic.length; i++) {
                for (let j = 0; j < chooseLovePic.length; j++) {
                  if (chooseLovePic[j].id == allLovePic[i].id) {
                    nowLovePic.splice(i, 1)
                  }
                }
              }
              let idsInfo = []
              for (let k = 0; k < nowLovePic.length; k++) {
                idsInfo.push({
                  id: nowLovePic[k].id,
                })
              }
              this.setLoveList(nowLovePic)
              sessionStorage.setItem("picLove", JSON.stringify(nowLovePic));
              this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
            } else {
              console.log('选用图片全部删除');
              sessionStorage.removeItem("picLove");
              this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
            }
            this.loveList = []
            this.setLoveList(this.loveList)
            this.isSavePic = false
          }



          this.handleCloseWork()
          this.setDrawer(false)
          setTimeout(() => {
            this.$router.push('/shareAndPush/myShare')
          }, 1500);
          this.$nextTick(() => {
            this.shareFlag = false
          })
          this.workForm = {}
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      // console.log('scrollTop',scrollTop)
      if (scroll < 0) {
        this.headerClass = 'elheaderdown'
      } else if (scrollTop > 75) {
        this.headerClass = 'elheaderup'
      }
    },
    downLoadPoint() {
      this.downLoadPointFlag=false
      // this.downloadFlag=false
    },
    handleClose () {
      this.setDrawer(false)
      this.downloadFlag = false
      this.shareFlag = false
      this.pushFlag = false
      this.downloadTitle = ""
      this.shareTitle = ""
      this.pushTitle = ""
    },
    openBatchChoose () {  //开启多选操作
      this.chooseArr = []
      if (this.switchFlag) {
        for (let i = 0; i < this.choosePic.length; i++) {
          this.chooseArr.push(this.choosePic[i].id);
        }
        let nowChoose = []
        for (let i = 0; i < this.choosePic.length; i++) {
          for (let j = 0; j < this.chooseArr.length; j++) {
            if (this.chooseArr[j] == this.choosePic[i].id) {
              nowChoose.push(this.choosePic[i])
            }
          }
        }
        sessionStorage.setItem('chooseArr', JSON.stringify(nowChoose))
      } else {
        sessionStorage.removeItem('chooseArr')
      }
      // console.log(123);
    },
    chooseImage (item) { //选中图片
      console.log(item);
      this.chooseArr.push(item.id);
      if (this.chooseArr.length == this.choosePic.length) {
        this.switchFlag = true
      }
      console.log(this.chooseArr);
      let nowChoose = []
      for (let i = 0; i < this.choosePic.length; i++) {
        for (let j = 0; j < this.chooseArr.length; j++) {
          if (this.chooseArr[j] == this.choosePic[i].id) {
            nowChoose.push(this.choosePic[i])
          }
        }
      }
      sessionStorage.setItem("chooseArr", JSON.stringify(nowChoose));

    },
    noChooseImage (id) { //取消选中图片
      this.switchFlag = false
      this.chooseArr.remove(id);
      let nowChoose = []
      for (let i = 0; i < this.choosePic.length; i++) {
        for (let j = 0; j < this.chooseArr.length; j++) {
          if (this.chooseArr[j] == this.choosePic[i].id) {
            nowChoose.push(this.choosePic[i])
          }
        }
      }
      sessionStorage.setItem("chooseArr", JSON.stringify(nowChoose));
    },
    picDelete(i,type) {
  console.log('111111111111111111',i,type);      
        this.$confirm('确认删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
          .then(e => {
            type=='video'?this.filterVideoList.splice(i, 1):this.filterPicList.splice(i,1)
            this.choosePic =[...this.filterPicList,...this.filterVideoList]
            // this.choosePic.splice(i, 1)
          this.loveList = []
          for (let i = 0; i < this.choosePic.length; i++) {
            this.loveList.push(this.choosePic[i].id)
          }
          this.setLoveList(this.loveList)
          sessionStorage.setItem("picLove", JSON.stringify(this.choosePic));
          let idsInfo = []
          for (let k = 0; k < this.choosePic.length; k++) {
            idsInfo.push({
              id: this.choosePic[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', idsInfo)
          this.$message.success('删除成功')
          if (this.loveList.length === 0) {
            this.isHavePic = false
          }
        })
        .catch(e => {
          console.log('取消', i)
        });
    },

    oneDelete () {
      this.$confirm('确认全部删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          // let path = this.$route.path
          // path = path.substr(1)
          this.loveList = []
          this.setLoveList(this.loveList)
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.isHavePic = false
          this.$message.success('删除成功')

        })
        .catch(e => {
          console.log('取消')
        });

    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取选用图片
    // async getUserSettingAsync (val, val2) {
    //   console.log(val, val2);
    //   return
    //   let value = {
    //     key: val2,
    //     uid: val
    //   }
    //   let { status, data, message, errors } = await getUserSetting(val, val2);
    //   if (status) {
    //     // console.log(data)
    //     let piclove = JSON.parse(data)
    //     if (piclove) {
    //       sessionStorage.setItem('picLove', piclove.value)
    //     }
    //   } else {
    //     let errortext = ''
    //     for (const key in errors) {
    //       errortext += errors[key]
    //     }
    //     this.$message.error({ message: message + errortext });
    //   }
    // },
    //获取选用图片
    async getUserSettingAsync (val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        this.choosePic = []
        // console.log('data',data);
        let piclove = JSON.parse(data);
        console.log(piclove,'piclove');
        if (piclove.value == null || data == []) {
          sessionStorage.removeItem("picLove");
        } else {
          let picIds = []

          let videoIds = []

          for (let i = 0; i < piclove.value.length; i++) {
            console.log( 'type',piclove.value[i].type );
            if (piclove.value[i].type=='video') {
              videoIds.push(piclove.value[i].id)
            } else {
              picIds.push(piclove.value[i].id)
            }
            
          }
          picIds = picIds.join(',');
          videoIds = videoIds.join(',');
          console.log(picIds);
          let idsInfo = {};
          if (picIds.length>0) {
            idsInfo = await getPictures({ ids: picIds });
            // console.log('idsInfo-----', idsInfo);
            idsInfo.data.forEach((ele) => {
              ele.srcW1080 = this.picPrefix + ele.fileInfo.picThumbW1080
              ele.src = this.picPrefix + ele.fileInfo.picThumbH160
              ele.type = 'pic'
            })
            
            // for (let j = 0; j < idsInfo.data.length; j++) {
            //   idsInfo.data[j].srcW1080 = this.picPrefix + idsInfo.data[j].fileInfo.picThumbW1080
            //   idsInfo.data[j].src = this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160
            //   idsInfo.data[j].type='pic'
            // }
          }
          let videoidsInfo = {};
          if (videoIds.length>0) {
            videoidsInfo = await getVideos({ ids: videoIds });
            videoidsInfo.data.forEach((ele) => {
              ele.src = this.picPrefix + ele.fileInfo.savepath
              ele.type = 'video'
            })
          }
          if (picIds.length > 0 && videoIds.length == 0) {
            sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data))
          }
          if (videoIds.length > 0 && picIds.length == 0) {
            sessionStorage.setItem("picLove", JSON.stringify(videoidsInfo.data))
          }
          if (videoIds.length > 0 && picIds.length > 0) {
            console.log(idsInfo.data);
            console.log(videoidsInfo.data);
            let sourceObj = [...idsInfo.data,...videoidsInfo.data];
            sessionStorage.setItem("picLove", JSON.stringify(sourceObj))
          }


          // if (idsInfo.data&&idsInfo.data.length>0 &&!videoidsInfo.hasOwnProperty('data')) {
          //   console.log('只有图片数据');
          //   sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));

          // }
          // if (videoidsInfo.data&&videoidsInfo.data.length>0&&!idsInfo.hasOwnProperty('data')) {
          //   console.log('值只有视频数据');
          // sessionStorage.setItem("picLove", JSON.stringify(videoidsInfo.data));

          // }
          // if (idsInfo.data && idsInfo.data.length > 0 && videoidsInfo.data && videoidsInfo.data.length > 0) {
          //   console.log(idsInfo.data);
          //   console.log(videoidsInfo.data);
          //   let sourceObj = Object.assign(idsInfo.data, videoidsInfo.data)
          //   console.log('sourceObj-----',sourceObj);
          //   sessionStorage.setItem("picLove", JSON.stringify(sourceObj));

          // }
          
          
          // let sourceObj=Object.assign(idsInfo.data,videoidsInfo.data)
          // console.log('-------sourceObj',sourceObj);
          // sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片包
    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("图片包添加成功！");
        this.switchFlag = false
        this.downloadTitle=""
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取允许的推送渠道
    async listAllowPushChannelAsync (val) {
      let { status, data, message, errors } = await listAllowPushChannel(val);
      if (status) {
        this.pushList = data

        this.template = this.pushList[0].template
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片邀约列表
    async listPictureNeedAsync (val) {
      let { status, data, message, pagination, errors } = await myPictureNeed(val);
      if (status) {
        this.picInviteList = data;

        if (data.length !== 0) {
          this.myform.name = this.picInviteList[0].title
          this.myform.id = this.picInviteList[0].id
        }

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        this.userList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取工作圈列表
    async listWorkgroupAsync (val) {
      let { status, data, message, errors } = await listWorkgroup(val);
      if (status) {
        this.workList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    async getAppBaseConfigAsync() {
      console.log('我执行了');
      let { status, data, message } = await getAppBaseConfig();
      if (status) {
        console.log('getAppBaseConfigAsync-------', data);
        this.isPointsEnable = data.pointsEnable == null ? 'false' : 'true'
        
        localStorage.setItem('isAuditEnabled', data.auditEnabled == null ? false : true)
        localStorage.setItem('isPointsEnable',data.pointsEnable==null? false : true)
        
        if (data.auditEnabled == null) {
          // 111
          this.asideList = this.asideList.filter((ele) => ele.field !== 'auditEnabled')
          this.asideList.forEach((ele) => {
            if (ele.url == '/myLib/myMediaAll') {
              ele.children  = ele.children.filter((ele) => !ele.isAuditEnabled)
              // console.log('arr---------------',arr);
            }
          })
          console.log(this.asideList,'------');
        }
        

      }
    },
  },
  created() {
    

    // this.getSimple()
    if (!localStorage.getItem('isAuditEnabled')&&!localStorage.getItem('isPointsEnable')) {
      this.getAppBaseConfigAsync();
    }
    if (localStorage.getItem('isPointsEnable')) {
    this.isPointsEnable=localStorage.getItem('isPointsEnable')
      
    }
    this.getUserSettingAsync(this.createUid, 'picLove')

    if (sessionStorage.getItem('isChro')) {
      this.isChro = false
    } else {
      this.isChro = !this.myBrowser()
    }
    // let isAuditEnabled = localStorage.getItem('isAuditEnabled')
    // console.log('isAuditEnabled----',isAuditEnabled);
    // if (!isAuditEnabled) {
    //       // 111
    //       this.asideList = this.asideList.filter((ele) => ele.field !== 'auditEnabled')
    //       this.asideList.forEach((ele) => {
    //         if (ele.url == '/myLib/myMediaAll') {
    //           ele.children  = ele.children.filter((ele) => ele.field !== 'baseConfig')
    //           // console.log('arr---------------',arr);
    //         }
    //       })

    //   }

    this.powers.push('setup')

    console.log('this.isSimple', this.isSimple);
    //简易版隐藏人物
    if (this.isSimple) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {

            if (this.asideList[i].children[j].text === '资源人物管理') {
              this.asideList[i].children.splice(j, 1)
            }

          }
          for (let j = 0; j < this.asideList[i].children.length; j++) {

            if (this.asideList[i].children[j].text === '智能节点管理') {
              this.asideList[i].children.splice(j, 1)
              if (!this.asideList[i].children[j]) {
                this.asideList.splice(i, 1)
                this.hidasideList.splice(i, 1)
              }
            }

          }

        }

      }

    }






    //分享与推送
    let zhandianOne = this.powers.indexOf('browseWebsiteCarousel')
    let zhandianTwo = this.powers.indexOf('manageWebsiteCarousel')
    let zhandianThree = this.powers.indexOf('browseWebsiteInfo')
    let zhandianFour = this.powers.indexOf('manageWebsiteInfo')
    if (zhandianOne === -1 && zhandianTwo === -1 && zhandianThree === -1 && zhandianFour === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {
            // console.log(this.asideList[i].children[j].text)
            if (this.asideList[i].children[j].text === '站点发布') {
              this.asideList[i].children.splice(j, 1)
            }
          }
        }
      }
    }

    //个人资源库
    // let myPicOne = this.powers.indexOf('myAtlas')
    // let myPicTwo = this.powers.indexOf('browseUnPicture')
    // let isAuditEnabled =
    // if () {
    //   for (let i = 0; i < this.hidasideList.length; i++) {
    //     if (this.hidasideList[i].text === '个人资源库') {
    //       this.hidasideList.splice(i, 1)
    //       this.asideList.splice(i, 1)
    //     }
    //   }
    // }

    //分享与推送
    let browseOne = this.powers.indexOf('browseDownload')
    let browseTwo = this.powers.indexOf('browsePush')
    let browseThree = this.powers.indexOf('browseShare')
    if (browseOne === -1 && browseTwo === -1 && browseThree === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.hidasideList[i].text === '分享与推送') {
          this.hidasideList.splice(i, 1)
          this.asideList.splice(i, 1)
        }
      }
    }

    //数智中心
    let aiOne = this.powers.indexOf('dataAnalysis')
    let aiTwo = this.powers.indexOf('manageIntelligentNode')
    let aiThree = this.powers.indexOf('myFace')
    if (aiOne === -1 && aiTwo === -1 && aiThree === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.hidasideList[i].text === '数智中心') {
          this.hidasideList.splice(i, 1)
          this.asideList.splice(i, 1)
        }
      }
    }

    //平台运维
    let operationOne = this.powers.indexOf('manageNas')
    let operationTwo = this.powers.indexOf('manageThirdPartyAccess')
    let operationThree = this.powers.indexOf('operationCommand')
    let operationFour = this.powers.indexOf('systemLogs')
    if (operationOne === -1 && operationTwo === -1 && operationThree === -1 && operationFour === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {
            // console.log(this.asideList[i].children[j].text)
            if (this.asideList[i].children[j].text === '平台运维') {
              this.asideList[i].children.splice(j, 1)
            }
          }
        }
      }
    }




    //活动投稿筛选
    let oneAct = this.powers.indexOf('checkPictureArticle')
    let twoAct = this.powers.indexOf('myPictureArticleFilter')
    let threeAct = this.powers.indexOf('manageAllPictureArticleFilter')
    let fourAct = this.powers.indexOf('outputPictureArticleFilter')
    let userOne = this.powers.indexOf('checkUserAuthInfo')
    let userTwo = this.powers.indexOf('searchUserAuthInfo')
    let userThree = this.powers.indexOf('outputUserAuthInfo')
    if (userOne === -1 && oneAct === -1 && threeAct === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.hidasideList[i].text === '工作流') {
          this.hidasideList.splice(i, 1)
          this.asideList.splice(i, 1)
        }
      }
    }
    if (oneAct === -1 && twoAct === -1 && threeAct === -1 && fourAct === -1 && userOne === -1 && userTwo === -1 && userThree === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.hidasideList[i].text === '工作流') {
          this.hidasideList.splice(i, 1)
          this.asideList.splice(i, 1)
        }
      }
    }

    if (oneAct === -1 && twoAct === -1 && threeAct === -1) {

      for (let i = 0; i < this.asideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {
            // console.log(this.asideList[i].children[j].text)
            if (this.asideList[i].children[j].text === '活动征稿') {
              this.asideList[i].children.splice(j, 1)
            }
          }
        }

      }
    }

    let auditEnabled = this.powers.indexOf('auditEnabled')
    // 没有审核图片权限
    if (auditEnabled==-1) {
      this.asideList=this.asideList.filter((ele)=>ele.field!=='auditEnabled')
    }


    let myAllAct = this.powers.indexOf('manageAllPictureActivity')
    let myAllNeed = this.powers.indexOf('manageAllPictureNeed')
    let myAct = this.powers.indexOf('myPictureActivity')
    let myNeed = this.powers.indexOf('myPictureNeed')
    let browseActivityArticle = this.powers.indexOf('browseActivityArticle')

    let live = this.powers.indexOf('manageAllActivityLive')
    let mylive = this.powers.indexOf('myActivityLive')

    if(live === -1 && mylive === -1){
      for (let i = 0; i < this.asideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {
            // console.log(this.asideList[i].children[j].text)
            if (this.asideList[i].children[j].text === '图片直播管理') {
              this.asideList[i].children.splice(j, 1)
            }
          }
        }

      }
    }
    if (myAllAct === -1 && myAllNeed === -1 && myAct === -1 && myNeed === -1 && browseActivityArticle === -1) {
      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.hidasideList[i].text === '邀约与征稿') {
          this.hidasideList.splice(i, 1)
          this.asideList.splice(i, 1)
        }
      }
    }
    if (myAllAct === -1 && myAct === -1) {

      for (let i = 0; i < this.asideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {
            // console.log(this.asideList[i].children[j].text)
            if (this.asideList[i].children[j].text === '征稿活动管理') {
              this.asideList[i].children.splice(j, 1)
            }
          }
        }

      }
    }
    if (myAllNeed === -1 && myNeed === -1) {

      for (let i = 0; i < this.asideList.length; i++) {
        if (this.asideList[i].children) {
          for (let j = 0; j < this.asideList[i].children.length; j++) {
            // console.log(this.asideList[i].children[j].text)
            if (this.asideList[i].children[j].text === '图片邀约管理') {
              this.asideList[i].children.splice(j, 1)
            }
          }
        }

      }
    }

    let one = this.powers.indexOf('activityThemeConfig')
    let two = this.powers.indexOf('baseConfig')
    let three = this.powers.indexOf('libConfig')
    let four = this.powers.indexOf('pushConfig')
    let five = this.powers.indexOf('roleConfig')
    let nine = this.powers.indexOf('userConfig')
    let ten = this.powers.indexOf('securityConfig')
    let setuponeone = this.powers.indexOf('ssoConfig')

    if (one === -1 && two === -1 && ten === -1 && three === -1 && four === -1 && five === -1 && nine === -1 && setuponeone === -1) {

      for (let i = 0; i < this.hidasideList.length; i++) {
        if (this.hidasideList[i].text === '系统设置') {
          this.hidasideList.splice(i, 1)
          this.asideList.splice(i, 1)
        }
      }
    }

    for (let j = 0; j < this.hidasideList.length; j++) {

      if (this.powers.indexOf(this.hidasideList[j].field) === -1) {
        this.hidasideList.splice(j, 1)
        j--
      }
      // console.log(this.hidasideList)
    }
    for (let z = 0; z < this.asideList.length; z++) {
      if (this.powers.indexOf(this.asideList[z].field) === -1) {
        this.asideList.splice(z, 1)
        z--
      } else {
        if (this.asideList[z].children) {
          for (let i = 0; i < this.asideList[z].children.length; i++) {
            if (this.powers.indexOf(this.asideList[z].children[i].field) === -1) {
              this.asideList[z].children.splice(i, 1)
              i--
            }
          }
          this.asideList[z].url = this.asideList[z].children[0].url
        }
      }
    }




    this.bus.$on('changeIsaside', (message) => {
      this.isAside = message
    })
    if (sessionStorage.getItem("picLove")) {
      let picLoveString = sessionStorage.getItem("picLove");
      this.choosePic = JSON.parse(picLoveString)
      console.log('picLoveString----',this.choosePic);
    
    for (let i = 0; i < this.choosePic.length; i++) {
      // this.choosePic[i].id = this.choosePic[i].resourceId
      try {
        if (this.choosePic[i].resourceId) {
          this.choosePic[i].id = this.choosePic[i].resourceId
        }
      } catch (error) {

      }
    }
    if (this.choosePic instanceof Array) {
      if (this.choosePic.length > 0) {
        this.choosePic.forEach(e => {
          if (e.type=='pic') {
            this.choosePicSrc.push(e.srcW1080)
          } else {
            this.choosePicSrc.push(e.src)
          }
            // this.choosePicSrc.push(e.srcW1080)

        });
      }
    }
    }
    


  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed () { //离开这个界面之后，删除，不然会有问题
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.disflex {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
.elheaderzw {
  width: 100%;
  height: 60px;
}
.el-header {
  width: 100%;
  // background: url("../../assets/myheader/headerbg.png") no-repeat;
  background-size: cover;
  background-attachment: fixed;
  color: #ffffff;
  /* text-align: center; */
  position: fixed;
  top: 0;
  height: 60px !important;
  z-index: 99;
}

.el-aside {
  color: #333;
  /* min-width: 60px; */
  /* text-align: center; */
  /* min-height: calc(100vh - 80px); */
}
.hidaside {
  background-color: #165ed5;
  /* margin-right: 20px; */
}
.simplehidaside {
  background-color: #de4d35;
  /* margin-right: 20px; */
}
.showaside {
  background-color: #fff;
  height: auto;
}
.el-main {
  min-height: calc(100vh - 60px);
  background-color: #f8f8f8;
  color: #333;
  padding: 0;
  transition: 0.5s;
}

body > .el-container {
  margin-bottom: 40px;
}

.elheaderup {
  animation: moveup 0.5s forwards linear;
}
.elheaderdown {
  animation: movedown 0.5s forwards linear;
}
@keyframes moveup {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-80px);
  }
}
@keyframes movedown {
  from {
    transform: translateY(-80px);
  }
  to {
    transform: translateY(0);
  }
}

.el-drawer__wrapper ::v-deep .el-drawer {
  width: 500px !important;
}

.el-drawer__wrapper {
  .header {
    height: 80px;
    display: flex;
    .goback {
      width: 40px;
      height: 100%;
      background-color: #194897;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .right {
      width: calc(100% - 40px);
      height: 100%;
      // background-color: #185dd2;
      padding: 5px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cleanup {
        display: flex;
        cursor: pointer;
        p {
          font-size: 16px;
          color: #fff;
          margin-left: 6px;
        }
      }
    }
  }

  .piclistbj {
    padding: 36px 30px;
    box-sizing: border-box;
    width: 100%;
    height: 580px;
    overflow-y: auto;
    background-color: #fcfcfc;
    position: relative;
    p {
      font-size: 16px;
      color: #333333;
    }
    ::v-deep .el-switch__label {
      color: #333333;
    }
    ::v-deep .el-switch {
      width: auto;
    }
    .piclist {
      display: flex;
      flex-wrap: wrap;
      // padding-top: 16px;
      padding-bottom: 155px;
      .pic {
        // width: 100px;
        height: 100px;
        margin-right: 6px;
        margin-bottom: 10px;
        position: relative;
        cursor: pointer;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .choose {
          width: 100px;
          height: 100px;
          position: absolute;
          top: 0px;
          right: 0;
          // background-color: rgba(0, 0, 0, 0.5);
          z-index: 999;
          .img {
            float: right;
            width: 20px;
            height: 20px;
          }
        }
        .icon {
          background: rgba(0, 0, 0, 0.6);
          border-radius: 3px;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 5px;
          left: 5px;
          transition: 0.3s;
          opacity: 0;
          i {
            font-size: 22px;
            color: white;
          }
        }

        &:hover .icon {
          opacity: 1;
        }
        .delete {
          background: rgba(0, 0, 0, 0.6);
          border-radius: 3px;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 5px;
          right: 5px;
          transition: 0.3s;
          opacity: 0;
        }

        &:hover .delete {
          opacity: 1;
        }
      }
    }
  }

  .check {
    width: 170px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: 10px;
    color: #333333;
    font-size: 14px;
    cursor: pointer;
    position: absolute;
    bottom: 240px;
    z-index: 1999;
    img {
      width: 20px;
      height: 20px;
    }
  }

  .drawerbtn {
    position: absolute;
    bottom: 0;
    width: 500px;
    height: 276px;
    background-color: #f3f3f3;
    text-align: center;
    padding-top: 44px;
    z-index: 999;
    .btnbj {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .rightinput {
        width: 200px;
        height: 55px;
        & ::v-deep .el-input__inner {
          height: 43px;
        }
      }

      .btt {
        width: 250px;
        height: 50px;
        background-color: #dddddd;
        border-radius: 25px;
        font-size: 15px;
        color: #333333;
        margin-left: 0;
        margin-bottom: 15px;
      }
    }

    .download {
      position: absolute;
      bottom: 0;
      width: 500px;
      height: 276px;
      background-color: rgba(0, 0, 0, 0.5);
      .el-input--small ::v-deep .el-input__inner {
        height: 48px;
      }
      .el-input-group--append ::v-deep .el-input__inner {
        border-radius: 30px 0 0 30px;
      }
      ::v-deep .el-input-group__append {
        border-radius: 0 30px 30px 0;
        color: #333333;
        font-size: 14px;
      }
    }

    .share {
      position: absolute;
      bottom: 0;
      width: 500px;
      height: 276px;
      background-color: rgba(0, 0, 0, 0.5);
      .el-input--small ::v-deep .el-input__inner {
        height: 48px;
      }
      .el-input-group--append ::v-deep .el-input__inner {
        border-radius: 30px 0 0 30px;
      }
      ::v-deep .el-input-group__append {
        border-radius: 0 30px 30px 0;
        color: #333333;
        font-size: 14px;
      }
    }

    .push {
      position: absolute;
      bottom: 0;
      width: 500px;
      height: 276px;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: left;
      overflow-y: auto;
      z-index: 11;
      p {
        font-size: 17px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }
      .pushbj {
        margin: 20px 0 0 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .pushlist {
          width: 190px;
          height: 50px;
          background: #919191;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          position: relative;
          cursor: pointer;
          img {
            position: absolute;
            right: 6px;
          }
        }
        .active {
          background: #185dd2;
        }
        .simpleactive {
          background: #fd9112;
        }
      }
      .sure {
        width: 180px;
        height: 50px;
        background: rgba(24, 93, 210, 1);
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin: 0 auto;
        cursor: pointer;
      }
    }
  }
}

.jianyi {
  position: fixed;
  bottom: 0;
  width: 600px;
  left: calc(50% - 300px);
  background: #185dd2;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px;
  box-sizing: border-box;
  font-weight: bold;
  div {
    cursor: pointer;
  }
}

.piclist ::v-deep .el-image-viewer__close {
  width: 5000px;
  height: 5000px;
  border-radius: 0%;
}
.imgs ::v-deep .el-icon-circle-close {
  margin-top: 100px;
  color: white;
}
::v-deep.el-dialog__title{
  color: #333 !important;
}
::v-deep.el-dialog__header{
  text-align: center;
}
</style>



